import ChartRatio from "./Charts/ChartRatio"
import ChartComparison from "./Charts/ChartComparison"
import ChartDetail from "./Charts/ChartDetail"
import ChartComparisonDay from "./Charts/ChartComparisonDay"

import TableDetailPackageByDay from "./Tables/TableDetailPackageByDay"
import TableDetailPackageByMonth from "./Tables/TableDetailPackageByMonth"

export {
    ChartRatio,
    ChartComparison,
    ChartDetail,
    ChartComparisonDay,

    TableDetailPackageByDay,
    TableDetailPackageByMonth,
}